import React from 'react';

const Logo = ({ size = 40, className = '', showText = true }) => {
  return (
    <div className={`inline-flex items-center justify-center bg-[#0F0E0C] ${className}`} style={{ width: size, height: size }}>
      <div className="flex flex-col items-center justify-center">
        <svg width={size * 0.42} height={size * 0.42} viewBox="0 0 40 40" fill="none">
          <path d="M28 6C22 9 18 15 18 22C18 29 22 35 28 38C22 38 12 34 12 22C12 10 22 6 28 6Z" stroke="#E8DFCC" strokeWidth="1.4" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        {showText && (
          <span className="text-[#E8DFCC] mt-0.5" style={{ fontSize: size * 0.11, letterSpacing: '0.22em', fontFamily: 'Inter, sans-serif', fontWeight: 500 }}>AURA LUNE</span>
        )}
      </div>
    </div>
  );
};

export default Logo;
